import{gql as e}from"@apollo/client";const m=e`
  mutation deleteSummaryFeedback($id: Int!) {
    summaryFeedback {
      deleteSummaryFeedback(id: $id)
    }
  }
`;export{m as DELETE_SUMMARY_FEEDBACK_MUTATION};
//# sourceMappingURL=useDeleteSummaryFeedback.graphql.js.map
